import { gql } from "@apollo/client";

export const EXPENSES = gql`
  query Expenses($tripId: ID!) {
    expenses(tripId: $tripId) {
      addedBy
      amount
      itemId
      author {
        _id
        displayName
        username
      }
      category {
        _id
        name
        order
        type
      }
      currency
      date
      description
      destination {
        _id
        city
        country
        normalised_city
        normalised_country
      }
      exchangeRateDate
      originalAmount
      paidBy {
        displayName
        username
        _id
      }
      paidFor {
        ratio
        amount
        user {
          _id
          currency
          displayName
          username
        }
        _id
      }
      settlementId
      pending
      _id
    }
  }
`;

export const SETTLEMENT = gql`
  query Settlement($tripId: ID!) {
    settlement(tripId: $tripId) {
      balances
      payments
      shares
      paid
    }
  }
`;

export const SETTLEMENTS = gql`
  query Settlements($tripId: ID!) {
    settlements(tripId: $tripId) {
      _id
      addedBy {
        displayName
      }
      balances
      createdAt
      expenses {
        amount
        currentUserAmount
        itemId
        author {
          _id
          displayName
          username
        }
        category {
          _id
          name
          order
          type
        }
        currency
        date
        description
        destination {
          _id
          city
          country
          normalised_city
          normalised_country
        }
        originalAmount
        _id
      }
      payments
      shares
      tripId
    }
  }
`;

export const CUSTOM_CATEGORIES = gql`
  query CustomCategories {
    customCategories {
      _id
      user {
        _id
        displayName
        username
      }
      name
      icon
      createdAt
      updatedAt
    }
  }
`;
